import { render, staticRenderFns } from "./SealManagement.vue?vue&type=template&id=3987f31a&scoped=true"
import script from "./SealManagement.vue?vue&type=script&lang=js"
export * from "./SealManagement.vue?vue&type=script&lang=js"
import style0 from "./SealManagement.vue?vue&type=style&index=0&id=3987f31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987f31a",
  null
  
)

export default component.exports